module.exports = __webpack_public_path__ + "static/deployment-6f0ed07e8664841ec3a8d2f611720711.png";